/**
 * Per-tenant entry/exit policy (SchoolService — `/EntryPolicySetting`).
 *
 * The SchoolService serializes PascalCase across the board (the runtime response
 * is `{ "LateEntryMaxLessonOrdinal", "EarlyExitToleranceMinutes", "IsDefault" }`),
 * so these DTOs are PascalCase too — 1:1 with the wire format, no mappers.
 *
 * This is stored config only — the gate/front enforces it; the service never
 * gates entry/exit itself. "Lesson" everywhere here means the student's REAL
 * lesson of the day (from the class timetable), not the slot position.
 */

/** GET/PUT `/EntryPolicySetting` response. */
export interface EntryPolicySetting {
  /**
   * Highest lesson (1-based, ordered by start time) a late-arriving student may
   * still enter. `null` = no cap (any lesson — the default), `1` = only the
   * first lesson, `N` = up to the Nth.
   */
  LateEntryMaxLessonOrdinal: number | null;
  /** Minutes BEFORE the end of the student's LAST lesson of the day they may leave (0 = only at the end). */
  EarlyExitToleranceMinutes: number;
  /** True while the tenant still uses the service defaults (no row stored). */
  IsDefault: boolean;
}

/** PUT `/EntryPolicySetting` body. */
export interface EntryPolicySettingRequest {
  LateEntryMaxLessonOrdinal: number | null;
  EarlyExitToleranceMinutes: number;
}

export interface EntryPolicySettingState {
  /** Effective policy from the last successful load/save (null until loaded). */
  setting: EntryPolicySetting | null;
}

export const initialEntryPolicySettingState: EntryPolicySettingState = {
  setting: null,
};
